
const getters = {
  listAll: state => {
    return state.user_list
  }
}
export default getters



//////////////////
// WEBPACK FOOTER
// ./state/user/user.getters.js
// module id = null
// module chunks = 